import BrowserDetect from './BrowserDetect';
import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import ToTop from './ToTop';
import Gmap from './Gmap';
import matchheight from 'jquery-match-height';
import link_icon from './link_icon';
import Swiper from 'swiper/dist/js/swiper.js';
import excecSpNavi from './excecSpNavi';
import fixedSidebar from './fixedSidebar';
import remodal from 'remodal';
import CurrentGmap from './CurrentGmap';
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());

/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
let bottom = 20,
    float_height = $('.float_nav').height();
if ($(window).width() >= 768) {
    // 768より大きいとき
    bottom = 20 + float_height;
} else {
    // 768より小さいとき
    bottom = 20 + float_height;
}
const param = {
    target: "#totop",
    stop_at: "#global_footer",
    bottom: bottom
};
const totop = new ToTop(param);
totop.exec();

/**
 * 外部リンク・PDF・Word・Exlsに_blankの自動付与
 *
 */
link_icon();

// ===============================================
// Swiper
// ===============================================
const home_mv_slide_pc = $('.home-mv-swiper-pc');
const home_mv_slide_pc_pg = $(home_mv_slide_pc).find('.swiper-pagination');
const home_mv_slide_sp = $('.home-mv-swiper-sp');
const home_mv_slide_sp_pg = $(home_mv_slide_sp).find('.swiper-pagination');

$(function () {
    const homeSlide_pc = new Swiper(home_mv_slide_pc, {
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },

        centeredSlides: true,
        effect: 'fade',
        slidesPerView: 1,
        loop: true,

        speed: 1000,
        spaceBetween: 0,

        // If we need pagination
        pagination: {
            el: home_mv_slide_pc_pg,
            clickable: true,
        }
        ,
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });

    const homeSlide_sp = new Swiper(home_mv_slide_sp, {
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },

        centeredSlides: true,
        effect: 'fade',
        slidesPerView: 1,
        loop: true,

        speed: 1000,
        spaceBetween: 0,

        // If we need pagination
        pagination: {
            el: home_mv_slide_sp_pg,
            clickable: true,
        }
        ,
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });

    const homePickUp = new Swiper('.home-pickup-swiper', {
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },

        centeredSlides: true,
        effect: 'fade',
        slidesPerView: 1,
        loop: true,

        speed: 1000,
        spaceBetween: 0,

        pagination: {
            el: '.swiper-pagination._pickup',
            clickable: true,
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
});

const school_slider = $('.school-slider');
const schoolSwiper = new Swiper(school_slider, {
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    centeredSlides: true,
    effect: 'fade',
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    on: {
        slideChangeTransitionStart: function () {
            let active = $('.swiper-slide-active').data('swiper-slide-index'),
                prev = $('.swiper-slide-prev').css('background-image'),
                next = $('.swiper-slide-next').css('background-image');

            $('.swiper-text-area p').fadeOut();
            $('.swiper-text-area p[data-slide-text=' + active + ']').fadeIn();
            $('.trim_slide._prev').css('background-image', prev);
            $('.trim_slide._next').css('background-image', next);
        }
    }
});

// ===============================================
// accordion(home_news)
// ===============================================
$('.home_news-header').on('click', function () {
    if ($('.home_news').hasClass('_is-active')) {
        $('.home_news-contents').slideUp();
        $('.home_news').removeClass('_is-active');
    } else {
        $('.home_news-contents').slideDown();
        $('.home_news').addClass('_is-active');
    }
});

// ===============================================
// accordion(FAQ)
// ===============================================

$('.accordion-title').on('click', function () {
    if (!$(this).hasClass('_no-open')) {
        $(this).next().slideToggle();
        $(this).toggleClass("_is-active");
    }
});

$('.js-sp-accroridon-table').each(function () {
    const $_that = $(this);
    const $_trigger = $_that.find('.js-sp-accroridon-table-trigger');

    $_trigger.each(function () {
        let target = $(this).find('.js-sp-accroridon-table-trigger-target');
        $(this).on('click', function () {
            $(target).slideToggle(100);
            $(this).toggleClass("_is-active");
        });
    });
});


$('.js-More').each(function () {
    let hidden_block = $(this).find('.js-hiddenBlock');
    let more_button = $(this).find('.js-MoreButton');

    $(hidden_block).css('display', 'none');
    $(more_button).on('click', function () {
        if ($(hidden_block).hasClass('_is-open')) {
            $(hidden_block).slideUp();
            $(hidden_block).removeClass('_is-open');
        } else {
            $(hidden_block).slideDown();
            $(hidden_block).addClass('_is-open');
        }
    })
});


// ===============================================
// .p-info-sidebar / .js-info-sidebar
// ===============================================
const parent = $('.js-info-sidebar-parent');
$(parent).each(function () {
    let child = $(this).find('.js-info-sidebar-child');
    if (child.length > 0) {
        $(this).on('click', function () {
            if (child.hasClass('_is-active')) {
                child.slideUp();
                child.removeClass('_is-active');
                $(this).find('.js-info-sidebar-parent-label').removeClass('_is-active');
            } else {
                child.slideDown();
                child.addClass('_is-active');
                $(this).find('.js-info-sidebar-parent-label').addClass('_is-active');
            }
        });
    }
});

// ===============================================
// .js-equal-height
// ===============================================

const js_equal_height = $('.js-equal-height');
if ($(js_equal_height).length > 0) {
    $(js_equal_height).each(function () {
        let target = $(this).find('.js-equal-height-target');
        let set_height = 0;
        $(target).each(function () {
            let target_height = $(this).height();
            if (set_height < target_height) {
                set_height = target_height;
            }
        });

        target.height(set_height);
    });
}

// ===============================================
// .p-school-tab
// ===============================================
$(function () {
    /*初期表示*/
    $('.ChangeElem_Panel').hide();
    $('.ChangeElem_Panel').eq(0).show();
    $('.ChangeElem_Btn').eq(0).addClass('is-active');
    /*クリックイベント*/
    $('.ChangeElem_Btn').each(function () {
        $(this).on('click', function () {
            var index = $('.ChangeElem_Btn').index(this);
            $('.ChangeElem_Btn').removeClass('is-active');
            $(this).addClass('is-active');
            $('.ChangeElem_Panel').hide();
            $('.ChangeElem_Panel').eq(index).show();
        });
    });
});

// ===============================================
// .scrollable-wrap
// ===============================================
$(window).on("load", function () {
    const scrollWrap = $(".scrollable-wrap");
    scrollWrap.each(function () {
        $(this).append("<div class='scrollable-wrap-image'></div>");
        $(this).append("<div class='scrollable-wrap-bg'></div>");

        let scrollHeight = scrollWrap.height();
        let scrollWidth = scrollWrap.width();

        const scrollBg = $(this).find(".scrollable-wrap-bg");
        const scrollImage = $(this).find(".scrollable-wrap-image");

        if (scrollHeight >= 170) {
            scrollImage.addClass("_high");
            let imageWidth = scrollImage.width();
            let positionCenter = (scrollWidth - imageWidth) / 2;
            scrollImage.css("left", positionCenter);
        } else {
            scrollImage.addClass("_low");
            let imageWidth = scrollImage.width();
            let positionCenter = (scrollWidth - imageWidth) / 2;
            scrollImage.css("left", positionCenter);
        }
        // スクロール量でクラス付与-消去
        $(this).scroll(function () {
            if ($(this).scrollLeft() > 5) {
                $(this).addClass("_is-active");
            } else {
                $(this).removeClass("_is-active");
            }
        });
        // クリックで画像と背景フェードアウト
        $(this).on("click", function () {
            scrollBg.fadeOut();
            scrollImage.fadeOut();
        });
    });
});

// ===============================================
// dont_tel
// ===============================================
function Dont_tel() {
    let dont_tel = $('.js-dont_tel');
    dont_tel.each(function () {
        let dont_tel_text = $(this).text();
        $(this).after(dont_tel_text);
        $(this).remove();
    });
}
$(window).on('load', function () {
    if ($(window).width() > 414) {
        Dont_tel();
    }
});

$(function () {
    const pnlink = $('.prev_next_link'),
        plink = $(pnlink).find('.prev').find('a'),
        nlink = $(pnlink).find('.next').find('a');
    if ($(window).width() <= 414) {
        $(plink).text('');
        $(nlink).text('');
    }
});

$(function () {
    const target = $('.js-ac-target');
    const btn = $('.js-ac-btn');
    const path = location.pathname;
    const path_array = path.split('/');
    const path_replace = path_array.join('-');
    const cookie_value = 'nijo_notice_' + path_replace;
    const cookie = document.cookie.indexOf(cookie_value);

    if (cookie !== -1) {
        btn.addClass('non-active');
        target.addClass('non-active');
    }

    btn.on('click', function () {
        if (target.hasClass('non-active')) {
            btn.removeClass('non-active');
            target.removeClass('non-active');
        } else {
            btn.addClass('non-active');
            target.addClass('non-active');
            document.cookie = cookie_value + '=' + cookie_value + '; path=/;';
        }
    })
})

// ===============================================
// remodal
// ===============================================
var inst = $('[data-remodal-id="popup-message"]').remodal();
if (inst) inst.open();
